export default "__VITE_ASSET__486fab5f__"